import RoomMatrix from '@/components/blocks/room-matrix/room-matrix';
import useQueryRoomMatrix from '@/integrations/content/content-modules/room-matrix/room-matrix.hooks';
import { useHotelContext } from '@/libraries/contexts/hotel-context/hotel-context';

export type RoomMatrixContainerProps =
  Content.Components['RoomMatrixHeadlessModuleDto'];

const RoomMatrixContainer = ({ id, pageId }: RoomMatrixContainerProps) => {
  const { parameters } = useHotelContext();

  const {
    data: dataRoomMatrix,
    isFetching: isFetchingRoomMatrix,
    isLoading: isLoadingRoomMatrix,
  } = useQueryRoomMatrix({
    parameters: parameters && {
      ...parameters,
      id,
      pageId,
    },
  });

  const hasNoResults =
    !isFetchingRoomMatrix &&
    !isLoadingRoomMatrix &&
    !dataRoomMatrix?.roomMatrix;

  if (hasNoResults) return null;

  if (isLoadingRoomMatrix || isFetchingRoomMatrix) {
    return <RoomMatrix isLoading />;
  }

  if (dataRoomMatrix) {
    return (
      <RoomMatrix
        enableHubspotform={dataRoomMatrix.enableHubspotform}
        enableRoomTypeFilter={dataRoomMatrix.enableRoomTypeFilter}
        facilitiesInRoom={dataRoomMatrix.facilitiesInRoom}
        headline={dataRoomMatrix.headline}
        link={dataRoomMatrix.link}
        roomMatrix={dataRoomMatrix.roomMatrix}
      />
    );
  }
};

RoomMatrixContainer.displayName = 'RoomMatrixContainer';

export default RoomMatrixContainer;
